import React from 'react';
import { Button } from '../../components/Button';
export function HeroSection() {
  return <section className="py-20 md:py-32 bg-cover bg-center bg-no-repeat relative" style={{
    backgroundImage: "url('https://cdn.magicpatterns.com/uploads/pX2go6QSUUZsZJYmMYXUhW/HeroBG.png')"
  }} data-id="element-307">
      <div className="absolute inset-0 bg-gradient-to-b from-header/30 via-transparent to-primary/40" data-id="element-308"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-309">
        <div className="text-center max-w-4xl mx-auto" data-id="element-310">
          <p className="text-sm font-semibold text-teal mb-4 tracking-widest uppercase load-fade-in-up stagger-1" data-id="element-311">
            Accepting new projects by referral only
          </p>
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight load-fade-in-up stagger-2" data-id="element-312">
            Custom Software Development by Referral
          </h1>
          <p className="text-xl md:text-2xl text-blue-200 mb-10 leading-relaxed load-fade-in-up stagger-3" data-id="element-313">
            Magnus Software builds tailored web applications, mobile apps, and
            AI-powered solutions for select clients. We partner with businesses
            through trusted referrals to deliver engineering excellence and
            measurable results.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center load-fade-in-up stagger-4" data-id="element-314">
            <Button variant="primary" size="lg" to="/contact" data-id="element-315">
              Discuss Your Project
            </Button>
            <Button variant="ghost" size="lg" className="border border-white/40 text-white hover:bg-white/10" to="/services" data-id="element-316">
              View Our Services
            </Button>
          </div>
        </div>
      </div>
    </section>;
}